// extracted by mini-css-extract-plugin
export var readonly = "_f9-1";
export var star = "_f9-0";